import React, { useState, useEffect } from 'react';
import api from '../services/api';

function Languages() {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    native_name: '',
    flag_emoji: '',
    enabled: true
  });
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const response = await api.get('/admin/languages');
      setLanguages(response.data);
    } catch (error) {
      console.error('Failed to fetch languages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/languages', formData);
      setMessage({ type: 'success', text: 'Language created successfully!' });
      setShowForm(false);
      setFormData({ code: '', name: '', native_name: '', flag_emoji: '', enabled: true });
      fetchLanguages();
    } catch (error) {
      setMessage({ type: 'error', text: error.message });
    }
  };

  const toggleEnabled = async (code, currentStatus) => {
    try {
      await api.put(`/admin/languages/${code}`, { enabled: !currentStatus });
      setMessage({ type: 'success', text: 'Language updated!' });
      fetchLanguages();
    } catch (error) {
      setMessage({ type: 'error', text: error.message });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Languages</h1>
        <p className="page-subtitle">Manage available languages</p>
      </div>

      {message && (
        <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-error'}`}>
          {message.text}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? 'Cancel' : '+ Add Language'}
        </button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '16px' }}>Add New Language</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Code (2 letters)</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.code}
                  onChange={(e) => setFormData({ ...formData, code: e.target.value.toUpperCase() })}
                  maxLength="2"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Native Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.native_name}
                  onChange={(e) => setFormData({ ...formData, native_name: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Flag Emoji</label>
                <input
                  type="text"
                  className="form-input"
                  value={formData.flag_emoji}
                  onChange={(e) => setFormData({ ...formData, flag_emoji: e.target.value })}
                  placeholder="🌍"
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Create Language
            </button>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Flag</th>
              <th>Name</th>
              <th>Native Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {languages.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '40px' }}>
                  No languages found
                </td>
              </tr>
            ) : (
              languages.map((lang) => (
                <tr key={lang.code}>
                  <td><strong>{lang.code}</strong></td>
                  <td style={{ fontSize: '24px' }}>{lang.flag_emoji}</td>
                  <td>{lang.name}</td>
                  <td>{lang.native_name}</td>
                  <td>
                    <span className={`badge ${lang.enabled ? 'badge-success' : 'badge-danger'}`}>
                      {lang.enabled ? 'Enabled' : 'Disabled'}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-icon"
                      onClick={() => toggleEnabled(lang.code, lang.enabled)}
                      title={lang.enabled ? 'Disable' : 'Enable'}
                    >
                      {lang.enabled ? '🔓' : '🔒'}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Languages;

